import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HomeRepairServiceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"home_repair_service"}/>
}
